import { useQueryClient } from "@tanstack/react-query";
import { FilterIcon } from "assets/icons";
import Button from "components/BaseWidgets/button";
import { useClearActivityLog } from "hooks/api/useActivityLog";

function PageHeader({ data, setCurrentPage, setShow }) {
  const queryClient = useQueryClient();
  const { mutate: clearLog, isPending } = useClearActivityLog({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["activity_log"] });
    },
  });

  return (
    <div className="flex items-center gap-3 justify-between">
      <div className="flex items-center gap-2">
        <span onClick={() => setShow(true)} className="">
          <FilterIcon />
        </span>
        <h1 className="font-title-lg fw-700 leading-3">Activity log</h1>
      </div>
      {data.length > 0 && (
        <Button
          isDisabled={isPending}
          onClick={() => {
            setCurrentPage(1);
            clearLog();
          }}
          variant="link"
        >
          Clear all
        </Button>
      )}
    </div>
  );
}

export default PageHeader;
